import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-amber-50 to-orange-50 border-t border-amber-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-6 sm:mb-8">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/fcdcc7c9-830c-42eb-b2c0-56a62fc1ea66.png"
              alt="VPB Logo"
              className="h-10 sm:h-12 w-auto mb-3 sm:mb-4"
              loading="lazy"
              decoding="async"
              width="120"
              height="48"
            />
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
              Servicio profesional de vaciado de pisos en Barcelona. Rápido, eficiente y sin complicaciones.
            </p>
          </div>

          <div>
            <h4 className="text-sm sm:text-base font-semibold text-gray-900 mb-3 sm:mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('inicio');
                    element?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-xs sm:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('servicios');
                    element?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-xs sm:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Servicios
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('costes');
                    element?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-xs sm:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Precios
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('contacto');
                    element?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-xs sm:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm sm:text-base font-semibold text-gray-900 mb-3 sm:mb-4">Contacto</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li className="flex items-center gap-2 sm:gap-3">
                <i className="ri-phone-line text-teal-600 flex-shrink-0"></i>
                <a href="tel:629501941" className="text-xs sm:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer break-all">
                  629 501 941
                </a>
              </li>
              <li className="flex items-center gap-2 sm:gap-3">
                <i className="ri-mail-line text-teal-600 flex-shrink-0"></i>
                <a href="mailto:info@vaciadopisosbarcelona.com.es" className="text-xs sm:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer break-all">
                  info@vaciadopisosbarcelona.com.es
                </a>
              </li>
              <li className="flex items-start gap-2 sm:gap-3">
                <i className="ri-map-pin-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-xs sm:text-sm text-gray-600">
                  Barcelona y área metropolitana
                </span>
              </li>
              <li className="flex items-center gap-2 sm:gap-3">
                <i className="ri-global-line text-teal-600 flex-shrink-0"></i>
                <span className="text-xs sm:text-sm text-gray-600 break-all">
                  vaciadopisosbarcelona.com.es
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm sm:text-base font-semibold text-gray-900 mb-3 sm:mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/aviso-legal"
                  className="text-xs sm:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Aviso legal
                </Link>
              </li>
              <li>
                <Link
                  to="/politica-privacidad"
                  className="text-xs sm:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Política de privacidad
                </Link>
              </li>
              <li>
                <Link
                  to="/politica-cookies"
                  className="text-xs sm:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Política de cookies
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-amber-200 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center gap-3 sm:gap-4">
          <p className="text-xs sm:text-sm text-gray-600 text-center md:text-left">
            © {currentYear} VPB. Todos los derechos reservados.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs sm:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}